export const ASSISTANT_MODES = {
  RESEARCH: 'research',
  HELP: 'help'
} as const

export type AssistantMode = (typeof ASSISTANT_MODES)[keyof typeof ASSISTANT_MODES]

export const DEFAULT_ASSISTANT_MODE: AssistantMode = ASSISTANT_MODES.RESEARCH

const ASSISTANT_MODE_SET = new Set<AssistantMode>(Object.values(ASSISTANT_MODES))

export const parseAssistantMode = (value: unknown): AssistantMode => {
  if (typeof value !== 'string') return DEFAULT_ASSISTANT_MODE
  return ASSISTANT_MODE_SET.has(value as AssistantMode)
    ? (value as AssistantMode)
    : DEFAULT_ASSISTANT_MODE
}
